// Input only type ...
export enum TagGroupAutoOverwriteGq {
  UNTAGGED_KEYWORDS_ONLY = 'UNTAGGED_KEYWORDS_ONLY',
  OVERWRITE_TAGGED_KEYWORDS = 'OVERWRITE_TAGGED_KEYWORDS',
  CLEAN_ALL_TAGS_AND_AUTOTAG = 'CLEAN_ALL_TAGS_AND_AUTOTAG',
}
